type GuardFn = (format: string) => boolean;

export const isPrimitiveType: GuardFn = (format) => ['string', 'number', 'boolean'].includes(format);
export const isUndefined: GuardFn = (format) => format === '"undefined"';
export const isNull: GuardFn = (format) => format === '"null"';
export const isUnion: GuardFn = (format) => {
  let depth = 0;
  let satisfies = false;
  format.split('').forEach((char) => {
    if (['{', '('].includes(char)) depth += 1;
    else if (['}', ')'].includes(char)) depth -= 1;
    else if (char === '|' && depth === 0) satisfies = true;
  });
  return satisfies;
};

export const isString: GuardFn = (format) => !isUnion(format) && format[0] === '"' && format.slice(-1) === '"';

export const isArray: GuardFn = (format) => !isUnion(format) && format.slice(-2) === '[]';

export const isObjectOf: GuardFn = (format) =>
  format !== 'object' && !isUnion(format) && format.startsWith('{ [key: string]: ');

export const isObject: GuardFn = (format) =>
  format === 'object' || (!isUnion(format) && format[0] === '{' && format.slice(-1) === '}');

export const isFunction: GuardFn = (format) => {
  // It's isn't an union
  if (isUnion(format)) return false;
  // Has to start with (( and end with )
  if (!format.startsWith('((') && format.slice(-1) !== ')') return false;

  // The arrow MUST occur at depth 1 (when couting parenthesis)
  // Otherwise the only possibility is that we have "something with parenthesis" (look down below)
  let depth = 0;
  let arrowOccursAtDepth1 = false;
  for (let i = 0; i < format.length; i += 1) {
    const char = format[i];
    if (['{', '('].includes(char)) depth += 1;
    else if (['}', ')'].includes(char)) depth -= 1;
    else if (i < format.length - 1 && format.slice(i, i + 2) === '=>') {
      arrowOccursAtDepth1 = arrowOccursAtDepth1 || depth === 1;
    }
  }
  return arrowOccursAtDepth1;
};

export const isJSXorNode: GuardFn = (format) => !isUnion(format) && ['React.ReactNode', 'JSX.Element'].includes(format);

export const isSomethingWithParenthesis: GuardFn = (format) =>
  !isUnion(format) && format[0] === '(' && format.slice(-1) === ')';
